/* NP Custom Carousel Arrows for Style Blocks */
(function() {
  if (window.innerWidth > 749) return;

  function initStyleBlockArrows() {
    var section = document.querySelector('[id*="section_9zdnbz"]');
    if (!section) return;

    var rows = section.querySelectorAll('.group-block-content.layout-panel-flex--row');
    var row = null;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].querySelectorAll(':scope > .group-block').length >= 3) {
        row = rows[i];
        break;
      }
    }
    if (!row || row.dataset.npArrows) return;
    row.dataset.npArrows = 'true';

    var wrapper = row.parentElement;
    wrapper.style.position = 'relative';

    var arrowSvg = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" style="width:20px;height:20px;"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4.5-4.5m4.5 4.5-4.5 4.5"/></svg>';

    function createArrow(direction) {
      var btn = document.createElement('button');
      btn.setAttribute('aria-label', direction === 'prev' ? 'Previous slide' : 'Next slide');
      btn.style.cssText = 'position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:44px;height:44px;border-radius:50%;background:rgb(250,81,162);color:#fff;border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;' + (direction === 'prev' ? 'left:-6px;' : 'right:-6px;');
      if (direction === 'prev') btn.style.transform = 'TranslateY(-50%) scaleX(-1)';
      btn.innerHTML = arrowSvg;
      return btn;
    }

    var prevBtn = createArrow('prev');
    var nextBtn = createArrow('next');
    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    function updateArrows() {
      var scrollLeft = row.scrollLeft;
      var maxScroll = row.scrollWidth - row.clientWidth;
      prevBtn.style.display = scrollLeft <= 5 ? 'none' : 'flex';
      nextBtn.style.display = scrollLeft >= maxScroll - 5 ? 'none' : 'flex';
    }

    function scrollByCard(direction) {
      var card = row.querySelector(':scope > .group-block');
      var cardWidth = card ? card.offsetWidth + parseInt(getComputedStyle(row).gap || 0) : 160;
      row.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function() { scrollByCard(-1); });
    nextBtn.addEventListener('click', function() { scrollByCard(1); });
    row.addEventListener('scroll', updateArrows);
    updateArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStyleBlockArrows);
  } else {
    initStyleBlockArrows();
  }
})();

/* PDP: Desktop image gallery – 2-image carousel with arrow navigation */
(function() {
  if (window.innerWidth < 750) return;

  function initGalleryCarousel() {
    var gallery = document.querySelector('media-gallery.media-gallery--grid');
    if (!gallery) return;
    var grid = gallery.querySelector('.media-gallery__grid');
    if (!grid || grid.dataset.npCarousel) return;
    grid.dataset.npCarousel = 'true';

    var items = grid.querySelectorAll('li.product-media-container');
    if (items.length <= 2) return;

    var currentIndex = 0;
    var maxIndex = items.length - 2;

    var arrowSvgPrev = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.75 10H4.25m0 0 4.5-4.5M4.25 10l4.5 4.5"/></svg>';
    var arrowSvgNext = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.25 10h11.5m0 0-4.5-4.5m4.5 4.5-4.5 4.5"/></svg>';

    var prevBtn = document.createElement('button');
    prevBtn.className = 'np-gallery-arrow np-gallery-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.type = 'button';
    prevBtn.innerHTML = arrowSvgPrev;

    var nextBtn = document.createElement('button');
    nextBtn.className = 'np-gallery-arrow np-gallery-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.type = 'button';
    nextBtn.innerHTML = arrowSvgNext;

    gallery.appendChild(prevBtn);
    gallery.appendChild(nextBtn);

    function updateArrows() {
      prevBtn.disabled = currentIndex === 0;
    }

    function scrollToIndex(idx) {
      if (idx > maxIndex) {
        idx = 0;
      }
      currentIndex = Math.max(0, idx);
      var item = items[currentIndex];
      if (item) {
        grid.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
      updateArrows();
    }

    prevBtn.addEventListener('click', function() { scrollToIndex(currentIndex - 1); });
    nextBtn.addEventListener('click', function() { scrollToIndex(currentIndex + 1); });

    updateArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryCarousel);
  } else {
    initGalleryCarousel();
  }

  document.addEventListener('np:gallery-replaced', function() {
    requestAnimationFrame(initGalleryCarousel);
  });
})();

/* PDP: Mirror inventory status into Size legend + keep Size Guide button alive */
(function() {
  function initSizeInventory() {
    var inv = document.querySelector('product-inventory');
    if (!inv) return;

    var syncing = false;
    var lastInventoryHTML = '';

    function findSizeFieldset() {
      return document.querySelector('.variant-option--default-width-buttons') ||
        document.querySelector('.variant-option--buttons:not(.variant-option--swatches)');
    }

    function readInventory() {
      var status = inv.querySelector('.product-inventory__status');
      return status ? status.innerHTML : '';
    }

    /* Re-inject the Size Guide button if missing after a re-render */
    function ensureSizeGuide(fieldset) {
      if (fieldset.querySelector('[data-np-sc-injected]')) return;
      var dialog = document.querySelector('.np-sc-modal-host dialog');
      if (!dialog) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'np-sc-modal-trigger np-sc-modal-trigger--inline';
      btn.setAttribute('data-np-sc-injected', '1');
      btn.innerHTML = 'Size guide<svg aria-hidden="true" focusable="false" class="np-sc-modal-icon" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2H2.5A1.5 1.5 0 0 0 1 3.5v8A1.5 1.5 0 0 0 2.5 13h8A1.5 1.5 0 0 0 12 11.5V8M8.5 1H13m0 0v4.5M13 1l-6 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.style.color = '#fa51a2';
      btn.style.setProperty('--np-sc-ul-color', '#fa51a2');
      btn.style.setProperty('--np-sc-ul-width', '1px');
      btn.addEventListener('click', function() { dialog.showModal(); });
      fieldset.appendChild(btn);
    }

    function sync() {
      if (syncing) return;
      syncing = true;

      var sizeFieldset = findSizeFieldset();
      if (!sizeFieldset) { syncing = false; return; }

      /* Inventory span in legend – only write if content changed or span missing */
      var legend = sizeFieldset.querySelector('legend');
      if (legend) {
        var span = legend.querySelector('.np-size-inventory');
        var html = readInventory();
        if (!span) {
          span = document.createElement('span');
          span.className = 'np-size-inventory';
          span.innerHTML = html;
          legend.appendChild(span);
          lastInventoryHTML = html;
        } else if (html !== lastInventoryHTML) {
          span.innerHTML = html;
          lastInventoryHTML = html;
        }
      }

      /* Size guide button */
      ensureSizeGuide(sizeFieldset);

      /* Keep original inventory block hidden */
      if (!inv.classList.contains('np-inventory-hidden')) {
        inv.classList.add('np-inventory-hidden');
      }

      syncing = false;
    }

    /* Initial sync */
    sync();
    inv.classList.add('np-inventory-hidden');

    /* Watch variant-picker for DOM re-renders */
    var picker = document.querySelector('variant-picker');
    if (picker) {
      new MutationObserver(function() {
        if (!syncing) sync();
      }).observe(picker, { childList: true, subtree: true });
    }

    /* Watch inventory element for content changes */
    new MutationObserver(function() {
      if (!syncing) sync();
    }).observe(inv, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeInventory);
  } else {
    initSizeInventory();
  }
})();

/* PDP: Wishlist Hero button – injected directly below Add to Cart button */
(function() {
  function tryInit() {
    var addToCartComponent = document.querySelector('add-to-cart-component');
    var wlhContainer = document.querySelector('#wishlisthero-product-page-button-container');
    if (!addToCartComponent || !wlhContainer) return false;
    if (addToCartComponent.dataset.npWlh) return true;
    addToCartComponent.dataset.npWlh = 'true';

    var appBlock = wlhContainer.closest('.shopify-app-block');

    /* Insert wishlist container immediately after the add-to-cart-component element */
    addToCartComponent.insertAdjacentElement('afterend', wlhContainer);
    wlhContainer.classList.add('np-wlh-inline');

    if (appBlock) appBlock.style.display = 'none';
    return true;
  }

  function initWishlistInline() {
    if (!tryInit()) {
      var observer = new MutationObserver(function() {
        if (tryInit()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistInline);
  } else {
    initWishlistInline();
  }
})();

/* PDP: Model switch – show current-model pill below gallery (colour-aware) */
(function() {
  function colourToSlug(val) {
    return (val || '').toLowerCase().replace(/\s+/g, '-');
  }

  function getSelectedColourSlug() {
    var colourFieldset = document.querySelector('.variant-option--swatches');
    if (!colourFieldset) return null;
    var checked = colourFieldset.querySelector('input:checked');
    return checked ? colourToSlug(checked.value) : null;
  }

  function initModelSwitch() {
    var gallery = document.querySelector('media-gallery.media-gallery--grid') ||
                  document.querySelector('media-gallery');
    if (!gallery) return;
    var grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    /* Remove any existing bar before re-scanning */
    var oldBar = document.querySelector('.np-model-switch');
    if (oldBar) oldBar.remove();
    delete grid.dataset.npModelSwitch;

    var items = Array.from(grid.querySelectorAll('li.product-media-container'));
    if (items.length === 0) return;

    var currentColour = getSelectedColourSlug();

    /* Find badge items that match the current colour (or have no colour tag) */
    var badgeItems = [];
    items.forEach(function(item, idx) {
      var badgeText = item.dataset.npBadge;
      if (!badgeText) return;
      var itemColour = item.dataset.npColour;
      /* Include if: no colour on this image, or no colour selected, or colours match */
      if (!itemColour || !currentColour || itemColour === currentColour) {
        badgeItems.push({ index: idx, text: badgeText.trim(), set: item.dataset.npSet || null });
      }
    });

    if (badgeItems.length === 0) return;

    /* Deduplicate by badge text – same text = same model set */
    var _seen = {};
    badgeItems = badgeItems.filter(function(b) {
      var _key = b.set || b.text;
      if (_seen[_key]) return false;
      _seen[_key] = true;
      return true;
    });

    grid.dataset.npModelSwitch = 'true';

    var hasMultipleSets = badgeItems.length >= 2;
    var setALabel = badgeItems[0].text;
    var setBLabel = hasMultipleSets ? badgeItems[1].text : '';
    var currentSet = 'A';

    var pill, btn;

    function extractSize(label) {
      var match = label.match(/size\s+(.+)$/i);
      return match ? match[1].trim() : label;
    }

    function updateBar() {
      if (!pill) return;
      pill.textContent = currentSet === 'A' ? setALabel : setBLabel;
      if (hasMultipleSets && btn) {
        btn.textContent = 'Switch to ' + extractSize(currentSet === 'A' ? setBLabel : setALabel) + ' \u2192';
      }
    }

    /* Build the bar */
    var bar = document.createElement('div');
    bar.className = 'np-model-switch';

    pill = document.createElement('span');
    pill.className = 'np-model-switch__pill';
    bar.appendChild(pill);

    if (hasMultipleSets) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'np-model-switch__btn';
      bar.appendChild(btn);

      /* Set switching: only used when same-colour has 2+ models */
      var setAStart = badgeItems[0].index;
      var setBStart = badgeItems[1].index;
      var setAId = badgeItems[0].set;
      var setBId = badgeItems[1].set;

      function showSet(set) {
        var allSlides = Array.from(document.querySelectorAll('slideshow-slide'));
        var slidesWithImg = allSlides.filter(function(s) { return !!s.querySelector('img'); });
        var slideMap = {};
        slidesWithImg.forEach(function(slide, i) {
          if (i < items.length) slideMap[i] = slide;
        });

        items.forEach(function(item, idx) {
          /* NP: Skip videos – handled by initVideoFirst */
          if (item.classList.contains('product-media-container--video') ||
              item.classList.contains('product-media-container--external_video')) return;
          /* Only touch items matching current colour (avoid overriding colour filter) */
          var itemColour = item.dataset.npColour;
          if (itemColour && currentColour && itemColour !== currentColour) return;

          var visible;
          if (setAId && setBId) {
            var itemSet = item.dataset.npSet;
            visible = !itemSet || (itemSet !== setAId && itemSet !== setBId) || itemSet === (set === 'A' ? setAId : setBId);
          } else {
            visible = idx < setAStart || (idx < setBStart ? set === 'A' : set === 'B');
          }
          item.style.display = visible ? '' : 'none';
          if (slideMap[idx]) slideMap[idx].style.display = visible ? '' : 'none';
        });
        currentSet = set;
        updateBar();
        grid.scrollTo({ left: 0, behavior: 'smooth' });
        var scroller = document.querySelector('slideshow-slides');
        if (scroller) scroller.scrollTo({ left: 0, behavior: 'smooth' });
      }

      btn.addEventListener('click', function() { showSet(currentSet === 'A' ? 'B' : 'A'); });
      showSet('A');
      setTimeout(function() { showSet(currentSet); }, 300);
    }

    gallery.insertAdjacentElement('afterend', bar);
    updateBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModelSwitch);
  } else {
    initModelSwitch();
  }

  document.addEventListener('np:gallery-replaced', function() {
    requestAnimationFrame(function() { requestAnimationFrame(initModelSwitch); });
  });
})();

/* PDP: Video-first – sticky video at gallery position 0 with colour matching */
(function() {
  var lastActiveVideoColour = null;

  function colourToSlug(val) {
    return (val || '').toLowerCase().replace(/\s+/g, '-');
  }

  function getSelectedColour() {
    var fs = document.querySelector('.variant-option--swatches');
    if (!fs) return null;
    var checked = fs.querySelector('input:checked');
    return checked ? colourToSlug(checked.value) : null;
  }

  function isVideoItem(li) {
    return li.classList.contains('product-media-container--video') ||
           li.classList.contains('product-media-container--external_video');
  }

  function initVideoFirst() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    var gridItems = Array.from(grid.querySelectorAll(':scope > li.product-media-container'));
    var videoItems = [];
    gridItems.forEach(function(li, idx) {
      if (isVideoItem(li)) {
        videoItems.push({ el: li, idx: idx, colour: li.dataset.npColour || null });
      }
    });

    if (videoItems.length === 0) return;

    /* Build slide map (same approach as colour filter) */
    var allSlides = Array.from(gallery.querySelectorAll('slideshow-slide'));
    var slidesWithImg = allSlides.filter(function(s) { return !!s.querySelector('img'); });
    var slideMap = {};
    slidesWithImg.forEach(function(slide, i) {
      if (i < gridItems.length) slideMap[i] = slide;
    });

    /* Single video: Liquid already placed it at position 0 */
    if (videoItems.length === 1) {
      lastActiveVideoColour = videoItems[0].colour;
      return;
    }

    /* Multiple videos: determine the active one */
    var currentColour = getSelectedColour();
    var activeVideo = null;

    /* 1. Colour match */
    if (currentColour) {
      for (var i = 0; i < videoItems.length; i++) {
        if (videoItems[i].colour === currentColour) {
          activeVideo = videoItems[i];
          break;
        }
      }
    }

    /* 2. Sticky match (last shown video's colour) */
    if (!activeVideo && lastActiveVideoColour) {
      for (var j = 0; j < videoItems.length; j++) {
        if (videoItems[j].colour === lastActiveVideoColour) {
          activeVideo = videoItems[j];
          break;
        }
      }
    }

    /* 3. Fallback: first video (Liquid already put it at position 0) */
    if (!activeVideo) {
      activeVideo = videoItems[0];
    }

    /* Update sticky state */
    if (activeVideo.colour) {
      lastActiveVideoColour = activeVideo.colour;
    }

    /* Hide non-active videos, show active video */
    videoItems.forEach(function(v) {
      var show = (v === activeVideo);
      v.el.classList.toggle('np-video-hidden', !show);
      if (slideMap[v.idx]) {
        slideMap[v.idx].classList.toggle('np-video-hidden', !show);
      }
    });

    /* If active video isn't at position 0, move it there (DOM reorder) */
    if (activeVideo.el !== gridItems[0]) {
      grid.insertBefore(activeVideo.el, grid.firstElementChild);
      if (slideMap[activeVideo.idx]) {
        var slideshowContainer = slideMap[activeVideo.idx].parentElement;
        if (slideshowContainer) {
          slideshowContainer.insertBefore(slideMap[activeVideo.idx], slideshowContainer.firstElementChild);
        }
      }
      /* Reset scroll to start */
      var slidesScroller = gallery.querySelector('slideshow-slides');
      if (slidesScroller) slidesScroller.scrollLeft = 0;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoFirst);
  } else {
    initVideoFirst();
  }

  document.addEventListener('np:gallery-replaced', function() {
    requestAnimationFrame(initVideoFirst);
  });
})();

/* PDP: filter gallery by selected colour variant */
(function() {
  function colourToSlug(val) {
    return (val || '').toLowerCase().replace(/\s+/g, '-');
  }

  function getSelectedColour() {
    var colourFieldset = document.querySelector('.variant-option--swatches');
    if (!colourFieldset) return null;
    var checked = colourFieldset.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  function initPdpColourFilter() {
    var gallery = document.querySelector('media-gallery.media-gallery--grid') ||
                  document.querySelector('media-gallery');
    if (!gallery) return;
    var grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('li.product-media-container'));
    var colouredItems = items.filter(function(li) { return !!li.dataset.npColour; });
    if (!colouredItems.length) return;

    var selectedColour = getSelectedColour();
    var colourSlug = selectedColour ? colourToSlug(selectedColour) : null;

    /* Build slide map in the same way as initModelSwitch */
    var allSlides = Array.from(document.querySelectorAll('slideshow-slide'));
    var slidesWithImg = allSlides.filter(function(s) { return !!s.querySelector('img'); });
    var slideMap = {};
    slidesWithImg.forEach(function(slide, i) {
      if (i < items.length) slideMap[i] = slide;
    });

    items.forEach(function(item, idx) {
      /* NP: Skip videos – handled by initVideoFirst */
      if (item.classList.contains('product-media-container--video') ||
          item.classList.contains('product-media-container--external_video')) return;
      var itemColour = item.dataset.npColour;
      var visible = !itemColour || !colourSlug || itemColour === colourSlug;
      item.style.display = visible ? '' : 'none';
      if (slideMap[idx]) slideMap[idx].style.display = visible ? '' : 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpColourFilter);
  } else {
    initPdpColourFilter();
  }

  document.addEventListener('np:gallery-replaced', function() {
    requestAnimationFrame(initPdpColourFilter);
  });
})();

/* PDP: MutationObserver – dispatch np:gallery-replaced when Tinker 4.1
   replaces the <media-gallery> element after a variant change */
(function() {
  var pdpObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeName === 'MEDIA-GALLERY') {
          document.dispatchEvent(new CustomEvent('np:gallery-replaced'));
        }
      });
    });
  });
  pdpObserver.observe(document.body, { childList: true, subtree: true });
})();

/* Fera reviews: rename "Show More" to "Read more" and open lightbox on click */
(function() {
  function upgradeShowMore(widget) {
    var links = widget.querySelectorAll('.fera-truncatedText-showMore:not([data-np-rm])');
    links.forEach(function(link) {
      link.setAttribute('data-np-rm', '1');
      link.textContent = 'Read more';
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        /* Click a non-link element inside the card so Fera's lightbox handler fires */
        var content = link.closest('.fera-review-content');
        var target = content && (content.querySelector('.fera-review-heading') ||
                                 content.querySelector('.fera-review-ratingAndDate'));
        if (target) {
          target.click();
        } else {
          var card = link.closest('.fera-review');
          if (card) card.click();
        }
      });
    });
  }

  function initFeraReadMore() {
    var widget = document.querySelector('.fera-productReviews-widget, .fera-reviews-widget');
    if (!widget) return;
    upgradeShowMore(widget);
    new MutationObserver(function() {
      upgradeShowMore(widget);
    }).observe(widget, { childList: true, subtree: true });
  }

  /* Fera loads asynchronously – watch for the widget to appear */
  var observer = new MutationObserver(function() {
    if (document.querySelector('.fera-productReviews-widget, .fera-reviews-widget')) {
      observer.disconnect();
      /* Small delay to let Fera finish rendering its initial cards */
      setTimeout(initFeraReadMore, 300);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

/* Fera reviews: force font sizes via JS (overrides Fera's own CSS injection) */
(function() {
  var SIZES = [
    /* Average rating number: reduced to match smaller stars */
    { sel: '.fera-averageRating-average-number', fontSize: '18px' },
    /* Average rating stars container */
    { sel: '.fera-averageRating-average-stars', fontSize: '18px' },
    /* Per-review stars: 20px -> 17px (-15%) */
    { sel: '.fera-review-rating', fontSize: '17px' },
    /* Review heading: 18px -> 16px */
    { sel: '.fera-review-heading', fontSize: '16px' },
    /* Review body: 14px -> 13px */
    { sel: '.fera-review-body', fontSize: '13px' }
  ];

  function applyFeraSizes(root) {
    root = root || document;
    SIZES.forEach(function(rule) {
      var els = root.querySelectorAll(rule.sel);
      els.forEach(function(el) {
        el.style.setProperty('font-size', rule.fontSize, 'important');
      });
    });
    /* Resize individual star b elements and fill slots — Fera sets these
       explicitly so CSS alone cannot override them */
    root.querySelectorAll('.fera-averageRating-average-stars b, .fera-averageRating-average-stars .fera-ratingFillSlot').forEach(function(el) {
      el.style.setProperty('font-size', '18px', 'important');
      el.style.setProperty('width', '18px', 'important');
      el.style.setProperty('min-width', '18px', 'important');
      el.style.setProperty('height', '18px', 'important');
      el.style.setProperty('margin-right', '4px', 'important');
    });
  }

  /* Watch for Fera to load */
  var observer = new MutationObserver(function() {
    if (document.querySelector('.fera-productReviews-widget, .fera-productDetailRating-widget, .fera-allReviews-widget, .fera-reviews-widget')) {
      observer.disconnect();
      setTimeout(function() {
        applyFeraSizes();
        /* Keep re-applying as Fera may re-render cards */
        new MutationObserver(function() {
          applyFeraSizes();
        }).observe(document.body, { childList: true, subtree: true });
      }, 200);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

/* Variant collection: show correct colour image on each colour card (no flicker) */
(function () {
  function initVariantCards() {
    var cards = document.querySelectorAll('li[data-np-colour]');
    if (!cards.length) return;

    cards.forEach(function (li) {
      if (li.dataset.npInit) return;
      li.dataset.npInit = '1';

      var colour = li.dataset.npColour;
      var variantId = li.dataset.npVariant;
      if (!colour) return;

      var productCard = li.querySelector('product-card');
      var slideshow = li.querySelector('slideshow-component');
      if (!productCard || !slideshow) return;

      var slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      var firstColourSlideId = null;

      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '') : '';
        var m = alt.match(/#colour_([^#]*?)(?:\s+#|$)/);
        var slideColour = m ? m[1].trim().toLowerCase() : null;

        if (slideColour === null) {
          slide.hidden = false;
        } else if (slideColour === colour) {
          slide.hidden = false;
          if (!firstColourSlideId) firstColourSlideId = slide.getAttribute('slide-id');
        } else {
          slide.hidden = true;
        }
      });

      /* Mark ready immediately if no colour-tagged slides found (nothing to switch) */
      if (!firstColourSlideId) {
        li.dataset.npReady = '1';
        return;
      }

      function goToColourSlide() {
        if (typeof slideshow.select === 'function') {
          slideshow.select({ id: firstColourSlideId }, undefined, { animate: false });
        }
        /* Reveal the card now that the correct slide is showing */
        li.dataset.npReady = '1';
      }

      if (typeof slideshow.select === 'function') {
        goToColourSlide();
      } else {
        customElements.whenDefined('slideshow-component').then(goToColourSlide);
      }

      productCard.resetImage = function (event) {
        if (event && event.pointerType !== 'mouse') return;
        goToColourSlide();
      };

      var colourLabel = li.dataset.npColourLabel || colour;
      var titleHeading = li.querySelector('[ref="productTitleLink"] p[role="heading"]');
      if (!titleHeading) titleHeading = li.querySelector('p[role="heading"]');
      if (titleHeading && colourLabel) {
        titleHeading.textContent = titleHeading.textContent.trimEnd() + ' - ' + colourLabel;
      }

      if (variantId) {
        li.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          try {
            var url = new URL(a.href);
            url.searchParams.set('variant', variantId);
            a.href = url.toString();
          } catch (e) { /* ignore */ }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(initVariantCards);
    });
  } else {
    requestAnimationFrame(initVariantCards);
  }
})();

/* PDP desktop: cap zoom dialog images to their native uploaded resolution */
(function() {
  if (window.innerWidth < 750) return;

  function capImageToNative(img) {
    if (!img.naturalWidth) return;
    img.style.maxWidth  = img.naturalWidth  + 'px';
    img.style.maxHeight = img.naturalHeight + 'px';
  }

  function watchImage(img) {
    if (img.complete && img.naturalWidth) {
      capImageToNative(img);
    } else {
      img.addEventListener('load', function() { capImageToNative(img); }, { once: true });
    }
  }

  function initZoomNativeSize() {
    var zoomDialog = document.querySelector('zoom-dialog');
    if (!zoomDialog || zoomDialog.dataset.npZoom) return;
    zoomDialog.dataset.npZoom = '1';
    zoomDialog.querySelectorAll('img.product-media__image').forEach(watchImage);
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.nodeName === 'IMG' && node.classList.contains('product-media__image')) {
            watchImage(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('img.product-media__image').forEach(watchImage);
          }
        });
      });
    }).observe(zoomDialog, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoomNativeSize);
  } else {
    initZoomNativeSize();
  }
})();

/* PDP desktop: zoom dialog – pink prev/next arrows */
(function() {
  if (window.innerWidth < 750) return;

  var SVG_PREV = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.75 10H4.25m0 0 4.5-4.5M4.25 10l4.5 4.5"/></svg>';
  var SVG_NEXT = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.25 10h11.5m0 0-4.5-4.5m4.5 4.5-4.5 4.5"/></svg>';

  function initZoomArrows(zd) {
    var dialog = zd.querySelector('dialog');
    if (!dialog || dialog.dataset.npZoomArrows) return;
    dialog.dataset.npZoomArrows = '1';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'np-gallery-arrow np-gallery-arrow--prev np-zoom-arrow';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = SVG_PREV;

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'np-gallery-arrow np-gallery-arrow--next np-zoom-arrow';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = SVG_NEXT;

    dialog.appendChild(prevBtn);
    dialog.appendChild(nextBtn);

    var currentIdx = 0;

    function items() {
      return Array.from(zd.querySelectorAll('.dialog-zoomed-gallery > li.product-media-container'));
    }

    function updateBtns() {
      var total = items().length;
      prevBtn.disabled = currentIdx <= 0;
      nextBtn.disabled = currentIdx >= total - 1;
    }

    /* Position arrows flush with the image's left/right edges */
    function positionArrows() {
      var gallery = zd.querySelector('.dialog-zoomed-gallery');
      if (!gallery) return;
      var list = items();
      if (!list.length) return;
      var visibleLi = list[currentIdx] || list[0];
      var img = visibleLi.querySelector('img.product-media__image');
      if (!img) return;
      var rect = img.getBoundingClientRect();
      if (!rect.width) return;
      var INSET = 14; /* px inside the image edge */
      prevBtn.style.left  = Math.max(8, rect.left  + INSET) + 'px';
      prevBtn.style.right = 'auto';
      nextBtn.style.right = Math.max(8, window.innerWidth - rect.right + INSET) + 'px';
      nextBtn.style.left  = 'auto';
    }

    function goTo(idx) {
      var list = items();
      idx = Math.max(0, Math.min(idx, list.length - 1));
      currentIdx = idx;
      if (typeof zd.selectThumbnail === 'function') {
        zd.selectThumbnail(idx, { behavior: 'smooth' });
      } else if (list[idx]) {
        list[idx].scrollIntoView({ behavior: 'smooth', inline: 'start' });
      }
      updateBtns();
      /* Re-position after scroll animation settles */
      setTimeout(positionArrows, 350);
    }

    prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentIdx - 1); });
    nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentIdx + 1); });

    /* Sync index on gallery scroll */
    var gallery = zd.querySelector('.dialog-zoomed-gallery');
    if (gallery) {
      gallery.addEventListener('scroll', function() {
        var list = items();
        if (!list.length) return;
        var w = list[0].offsetWidth || gallery.offsetWidth;
        var idx = Math.round(gallery.scrollLeft / w);
        idx = Math.max(0, Math.min(idx, list.length - 1));
        if (idx !== currentIdx) { currentIdx = idx; updateBtns(); }
        positionArrows();
      });
    }

    /* Re-position whenever an image in the dialog loads (incl. high-res swap) */
    new MutationObserver(function() {
      requestAnimationFrame(positionArrows);
    }).observe(zd, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

    dialog.addEventListener('close', function() { currentIdx = 0; updateBtns(); });

    /* Initial position after dialog opens */
    new MutationObserver(function(_, obs) {
      if (dialog.open) { setTimeout(positionArrows, 50); }
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });

    updateBtns();
  }

  function tryInit() {
    var zd = document.querySelector('zoom-dialog');
    if (zd) initZoomArrows(zd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();

// Fera reviews: limit initial visible cards to 8, trim container height
(function () {
  var LIMIT = 8;
  var limited = false;

  function applyLimit() {
    if (limited) return;
    var items = document.querySelector('.fera-reviews-body-items');
    if (!items) return;
    var reviews = Array.prototype.slice.call(items.querySelectorAll('.fera-review'));
    if (reviews.length <= LIMIT) return;
    if (!reviews[0].style.transform) return; // wait for Fera masonry to finish positioning

    limited = true;

    var containerTop = items.getBoundingClientRect().top;
    var maxBottom = 0;
    reviews.slice(0, LIMIT).forEach(function (r) {
      var b = r.getBoundingClientRect().bottom - containerTop;
      if (b > maxBottom) maxBottom = b;
    });

    reviews.slice(LIMIT).forEach(function (r) { r.style.display = 'none'; });
    items.style.height = (maxBottom + 16) + 'px';

    var btn = document.querySelector('.fera-reviews-showMore-btn');
    if (btn) {
      btn.addEventListener('click', function () {
        reviews.slice(LIMIT).forEach(function (r) { r.style.display = ''; });
        items.style.height = '';
      }, { once: true });
    }
  }

  new MutationObserver(function () {
    if (!limited) applyLimit();
  }).observe(document.body, { childList: true, subtree: true });

  applyLimit();
})();

/* Fera all-reviews page: auto-click Show More to pre-load more reviews */
(function() {
  var AUTO_CLICKS = 2; /* click Show More this many times automatically */

  function autoExpand(clicksLeft) {
    if (clicksLeft <= 0) return;
    var btn = document.querySelector('.fera-reviews-showMore-btn');
    if (!btn) return;
    btn.click();
    setTimeout(function() { autoExpand(clicksLeft - 1); }, 800);
  }

  var observer = new MutationObserver(function() {
    if (document.querySelector('.fera-allReviews-widget, .fera-reviews-widget')) {
      observer.disconnect();
      setTimeout(function() { autoExpand(AUTO_CLICKS); }, 600);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// PDP mobile: move FAQ accordion from right column to after
// below-images FAQ group (before reviews) so mobile order is:
// tech icons > tech features > how sesi > materials > FAQ accordion
(function() {
  if (window.innerWidth >= 750) return;
  function moveFaqOnMobile() {
    var right = document.querySelector('.np-product__right');
    if (!right) return;
    var accordion = right.querySelector('.accordion[class*="accordion--"]');
    if (!accordion) return;
    var belowImages = document.querySelector('.np-product__below-images');
    if (!belowImages) return;
    var feraBlock = belowImages.querySelector('[id*="fera"]');
    if (feraBlock) {
      belowImages.insertBefore(accordion, feraBlock);
    } else {
      belowImages.appendChild(accordion);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveFaqOnMobile);
  } else {
    moveFaqOnMobile();
  }
})();

/* Variant carousel: fix quick-add in variant cards
   The core quick-add.js only looks for <product-card> ancestors,
   but variant carousel uses .variant-card divs. This patches
   quick-add-component instances inside variant cards to find the
   product URL from the nearest .variant-card__link ancestor. */
(function() {
  function patchQuickAdd(qac) {
    if (qac.dataset.npVcPatched) return;
    var variantCard = qac.closest('.variant-card');
    if (!variantCard) return;
    qac.dataset.npVcPatched = '1';

    var link = variantCard.querySelector('a.variant-card__link');
    if (!link || !link.href) return;

    Object.defineProperty(qac, 'productPageUrl', {
      get: function() {
        return link.href;
      },
      configurable: true
    });
  }

  function patchAll() {
    document.querySelectorAll('.variant-card quick-add-component:not([data-np-vc-patched])').forEach(patchQuickAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAll);
  } else {
    patchAll();
  }

  new MutationObserver(patchAll).observe(document.body, { childList: true, subtree: true });
})();

/* Quick-add: loading spinner while product page is being fetched */
(function() {
  /* Show loading state on click */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.quick-add__button--choose');
    if (!btn) return;
    var qac = btn.closest('quick-add-component');
    if (qac) qac.classList.add('np-quick-add-loading');
  }, true);

  /* Clear loading state when modal dialog opens */
  function clearLoadingOnOpen() {
    var dialog = document.getElementById('quick-add-dialog');
    if (!dialog || dialog.dataset.npLoadWatch) return;
    dialog.dataset.npLoadWatch = '1';
    new MutationObserver(function() {
      var d = dialog.querySelector('dialog');
      if (d && d.open) {
        document.querySelectorAll('.np-quick-add-loading').forEach(function(el) {
          el.classList.remove('np-quick-add-loading');
        });
      }
    }).observe(dialog, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearLoadingOnOpen);
  } else {
    clearLoadingOnOpen();
  }
  new MutationObserver(clearLoadingOnOpen).observe(document.body, { childList: true, subtree: true });
})();

/* Quick-add: viewport prefetch - fetch product pages as cards scroll into view
   and cache the parsed DOM so quick-add opens instantly.
   Also patches QuickAddComponent.fetchProductPage to use the cache. */
(function() {
  var cache = {}; /* url -> Promise<Document|null> */
  var count = 0;
  var MAX = 12;

  function getProductUrl(card) {
    var link = card.querySelector('a.variant-card__link');
    if (link && link.href) return link.href;
    link = card.querySelector('a[href*="/products/"]');
    if (link && link.href) return link.href;
    return '';
  }

  function prefetchUrl(url) {
    if (!url || cache[url] || count >= MAX) return;
    count++;
    cache[url] = fetch(url)
      .then(function(r) { return r.ok ? r.text() : null; })
      .then(function(text) {
        return text ? new DOMParser().parseFromString(text, 'text/html') : null;
      })
      .catch(function() { return null; });
  }

  function onIntersect(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      prefetchUrl(getProductUrl(entry.target));
    });
  }

  function init() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(onIntersect, {
      rootMargin: '200px 0px'
    });
    document.querySelectorAll('.variant-card, product-card').forEach(function(card) {
      card.dataset.npPf = '1';
      observer.observe(card);
    });
    new MutationObserver(function() {
      document.querySelectorAll('.variant-card:not([data-np-pf]), product-card:not([data-np-pf])').forEach(function(card) {
        card.dataset.npPf = '1';
        observer.observe(card);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Patch QuickAddComponent.fetchProductPage to use our cache */
  function patchQuickAdd() {
    var CE = customElements.get('quick-add-component');
    if (!CE || CE.__npPrefetchPatched) return;
    CE.__npPrefetchPatched = true;
    var origFetch = CE.prototype.fetchProductPage;
    CE.prototype.fetchProductPage = function(url) {
      if (cache[url]) return cache[url];
      return origFetch.call(this, url);
    };
  }

  /* Also prefetch on pointerdown as a fallback */
  document.addEventListener('pointerdown', function(e) {
    var btn = e.target.closest('.quick-add__button--choose');
    if (!btn) return;
    var qac = btn.closest('quick-add-component');
    var url = qac ? qac.productPageUrl : '';
    if (url && !cache[url]) {
      cache[url] = fetch(url)
        .then(function(r) { return r.ok ? r.text() : null; })
        .then(function(text) {
          return text ? new DOMParser().parseFromString(text, 'text/html') : null;
        })
        .catch(function() { return null; });
    }
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); patchQuickAdd(); });
  } else {
    init();
    patchQuickAdd();
  }
  /* Retry patching in case custom element is defined late */
  new MutationObserver(function() { patchQuickAdd(); }).observe(document.body, { childList: true, subtree: true });
})();

/* Quick-add modal: move inventory count next to last size button */
(function() {
  function moveInventory() {
    var dialog = document.getElementById('quick-add-dialog');
    if (!dialog) return;
    var d = dialog.querySelector('dialog');
    if (!d || !d.open) return;
    /* Already processed this dialog instance */
    if (dialog.querySelector('.np-qa-inventory')) return;
    var inv = dialog.querySelector('product-inventory');
    if (!inv) return;
    var text = (inv.textContent || '').trim();
    if (!text) return;
    /* Find the Size variant-option fieldset */
    var opts = dialog.querySelectorAll('.variant-option');
    var sizeFieldset = null;
    opts.forEach(function(o) {
      var leg = o.querySelector('legend');
      if (leg && /size/i.test(leg.textContent)) sizeFieldset = o;
    });
    if (!sizeFieldset) return;
    inv.style.setProperty('display', 'none', 'important');
    var span = document.createElement('span');
    span.className = 'np-qa-inventory';
    span.textContent = text;
    sizeFieldset.appendChild(span);
  }

  /* Watch for dialog open and retry with delay for DOM settling */
  new MutationObserver(function() {
    var dialog = document.getElementById('quick-add-dialog');
    if (!dialog) return;
    var d = dialog.querySelector('dialog');
    if (d && d.open && !dialog.querySelector('.np-qa-inventory')) {
      setTimeout(moveInventory, 150);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
})();

/* Fera: enforce star sizes after Fera JS re-renders the widget */
(function() {
  function enforceFeraStarSize() {
    var widgets = document.querySelectorAll('.fera-productDetailRating-widget');
    widgets.forEach(function(w) {
      w.style.setProperty('margin', '4px 0', 'important');
      var stars = w.querySelectorAll('.fera-averageRating-average-stars b');
      stars.forEach(function(b) {
        b.style.setProperty('font-size', '14px', 'important');
        b.style.setProperty('width', '14px', 'important');
        b.style.setProperty('height', '14px', 'important');
        b.style.setProperty('margin', '0', 'important');
        b.style.setProperty('padding', '0', 'important');
      });
      var starContainer = w.querySelector('.fera-averageRating-average-stars');
      if (starContainer) {
        starContainer.style.setProperty('font-size', '14px', 'important');
        starContainer.style.setProperty('letter-spacing', '-1px', 'important');
        starContainer.style.setProperty('gap', '0', 'important');
      }
      var num = w.querySelector('.fera-averageRating-average-number');
      if (num) num.style.setProperty('font-size', '14px', 'important');
      var count = w.querySelector('.fera-averageRating-count');
      if (count) count.style.setProperty('font-size', '12px', 'important');
      var countStr = w.querySelector('.fera-averageRating-count-str');
      if (countStr) countStr.style.setProperty('font-size', '12px', 'important');
      /* Reveal widget now that sizes are enforced */
      if (!w.classList.contains('np-fera-ready')) {
        w.classList.add('np-fera-ready');
      }
    });
  }

  /* Run on any Fera container mutations */
  var feraContainers = document.querySelectorAll('[data-fera-container="product_reviews_summary"]');
  if (feraContainers.length) {
    feraContainers.forEach(function(c) {
      new MutationObserver(function() { enforceFeraStarSize(); })
        .observe(c, { childList: true, subtree: true, attributes: true, characterData: true });
    });
    enforceFeraStarSize();
  } else {
    /* Container not yet in DOM — watch for it */
    new MutationObserver(function(mutations, obs) {
      var c = document.querySelector('[data-fera-container="product_reviews_summary"]');
      if (c) {
        new MutationObserver(function() { enforceFeraStarSize(); })
          .observe(c, { childList: true, subtree: true, attributes: true, characterData: true });
        enforceFeraStarSize();
        obs.disconnect();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Product card swatches: show all colours instead of "+N" overflow */
(function() {
  function showAllSwatches() {
    document.querySelectorAll('product-card overflow-list').forEach(function(ol) {
      /* Remove slot="overflow" so hidden swatches render in the default slot */
      ol.querySelectorAll('[slot="overflow"]').forEach(function(li) {
        li.removeAttribute('slot');
      });
      /* Update shadow DOM ul to auto height and tighter gap */
      if (ol.shadowRoot) {
        var ul = ol.shadowRoot.querySelector('ul');
        if (ul) {
          ul.style.setProperty('height', 'auto', 'important');
          ul.style.setProperty('flex-wrap', 'wrap', 'important');
          ul.style.setProperty('gap', '4px', 'important');
        }
        /* Hide the "More" button */
        var more = ol.shadowRoot.querySelector('[part="more"]');
        if (more) more.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* Run after page load and re-run when overflow-list recalculates */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(showAllSwatches, 500); });
  } else {
    setTimeout(showAllSwatches, 500);
  }
  /* Watch for overflow-list recalculations */
  new MutationObserver(function() { showAllSwatches(); })
    .observe(document.body, { childList: true, subtree: true, attributeFilter: ['slot'] });
})();

/* Mobile: fix heading text wrapping - replace nbsp with regular spaces
   (so long phrases can wrap at word boundaries) and replace hyphens with
   non-breaking hyphens (so compound words like 5-star don't split) */
(function() {
  if (window.innerWidth >= 750) return;
  function fixHeadingWrap() {
    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function(h) {
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT);
      var node;
      while (node = walker.nextNode()) {
        var t = node.textContent;
        var changed = false;
        if (t.indexOf('\u00A0') !== -1) { t = t.replace(/\u00A0/g, ' '); changed = true; }
        if (t.indexOf('-') !== -1) { t = t.replace(/-/g, '\u2011'); changed = true; }
        if (changed) node.textContent = t;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHeadingWrap);
  } else {
    fixHeadingWrap();
  }
})();



/* Fera review carousel: equalize slide heights + fix lazy image loading */
(function() {
  function fixFeraCarousel() {
    var slides = document.querySelectorAll('.fera-slider-slide.fera-review');
    if (!slides.length) return;

    /* Fix lazy-loaded images on clone/off-screen slides */
    var imgs = document.querySelectorAll('.fera-slider-slide.fera-review img[loading="lazy"]');
    imgs.forEach(function(img) {
      img.loading = 'eager';
      var src = img.src;
      img.src = '';
      img.src = src;
    });

    /* Remove drop shadow from Fera arrows (CSS handles color) */
    document.querySelectorAll(".fera-media-nav-caret-icon g[filter]").forEach(function(g) { g.removeAttribute("filter"); });
    /* Equalize heights to most common (mode) height */
    slides.forEach(function(s) { s.style.height = ''; });
    var counts = {};
    slides.forEach(function(s) {
      var h = Math.round(s.getBoundingClientRect().height);
      counts[h] = (counts[h] || 0) + 1;
    });
    var modeH = 0, modeCount = 0;
    Object.keys(counts).forEach(function(h) {
      if (counts[h] > modeCount) { modeCount = counts[h]; modeH = Number(h); }
    });
    if (modeH > 0) {
      slides.forEach(function(s) { s.style.height = modeH + 'px'; });
    }
  }
  var observer = new MutationObserver(function(mutations) {
    var hasNew = mutations.some(function(m) { return m.addedNodes.length > 0; });
    if (hasNew) {
      var slides = document.querySelectorAll('.fera-slider-slide.fera-review');
      if (slides.length) { fixFeraCarousel(); observer.disconnect(); }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', function() {
    clearTimeout(window._feraResizeTimer);
    window._feraResizeTimer = setTimeout(fixFeraCarousel, 200);
  });
})();

/* ── Fera review carousel: force-load lazy thumbnails that Fera's observer misses ── */
(function() {
  function loadFeraThumbs() {
    document.querySelectorAll('.fera-media-thumbnail-image[data-src]').forEach(function(img) {
      if (!img.getAttribute('src') && img.getAttribute('data-src')) {
        img.src = img.getAttribute('data-src');
      }
    });
  }
  var obs = new MutationObserver(function() {
    if (document.querySelector('.fera-media-thumbnail-image[data-src]')) {
      loadFeraThumbs();
      obs.disconnect();
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();

/* ── Clearance PDP: hide Klaviyo BIS "Notify Me" button, show "Sold out" ── */
(function() {
  if (!window.location.pathname.includes('-clearance')) return;
  var obs = new MutationObserver(function() {
    var bisContainer = document.getElementById('klaviyo-bis-button-container');
    if (!bisContainer || !bisContainer.children.length) return;
    bisContainer.style.display = 'none';
    var soldOut = bisContainer.closest('add-to-cart-component')
      ?.querySelector('.add-to-cart-button');
    if (soldOut) soldOut.style.removeProperty('display');
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
